import React, { FC, useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { RouteComponentProps } from 'react-router-dom'
import Node from './components/node'
import Config from './components/config'
import Canvas from './components/canvas'
import Header from './components/header'
import { Modal, Form, InputNumber, Button } from 'antd'
import { setInstance } from '@/store/actions/material'
import { createCanvas } from './createNode'
import { getMaterialById } from '@/services/creativeMaterialService'
import './material.scss'
const layout = {
  labelCol: { span: 6 },
  wrapperCol: { span: 16 },
}

const modalFormRules = {
  width: [{ required: true, message: 'Please input your username!' }],
  height: [{ required: true, message: 'Please input your password!' }],
}
const formStyle = {
  width100: { width: '100%' },
}
export interface MaterialRouteProps {
  id: string
  type: 'import' | 'editor'
}
interface MaterialProps {
  instance: any
  setInstance: (instance: any) => void
}

const Material: FC<MaterialProps & RouteComponentProps<MaterialRouteProps>> = ({
  instance,
  setInstance,
  match,
}) => {
  const [modalFormInstance] = Form.useForm()
  const [isModalVisible, setIsModalVisible] = useState(false)
  useEffect(() => {
    const id = match.params.id
    let newInstance
    if (instance) {
      if (!(document.getElementById('canvas') as HTMLCanvasElement)?.width) {
        const { width, height } = instance
        newInstance = createCanvas('canvas', { width, height })
        id
          ? getMaterialById(id).then(res => {
              const { meta, content } = res.data
              newInstance.loadFromJSON(content, () => {
                newInstance.setWidth(meta.width)
                newInstance.setHeight(meta.height)
              })
            })
          : newInstance.loadFromJSON(instance.toJSON())
        setInstance(newInstance)
      }
    } else {
      id
        ? getMaterialById(id).then(res => {
            const { meta, content } = res.data
            const { width, height } = meta
            newInstance = createCanvas('canvas', { width, height })
            newInstance.loadFromJSON(content, () => {
              newInstance.setWidth(width)
              newInstance.setHeight(height)
            })
            setInstance(newInstance)
          })
        : setIsModalVisible(true)
    }
  }, [instance, setInstance, match.params.id])

  const handleOk = () => {
    modalFormInstance.validateFields().then(res => {
      const canvasInstace = createCanvas('canvas', res)
      setInstance(canvasInstace)
      setIsModalVisible(false)
    })
  }

  return (
    <div className="material-wrapper">
      <Header instance={instance} />
      <Node />
      <Canvas />
      <Config />
      <Modal
        title="新建画布"
        visible={isModalVisible}
        centered
        destroyOnClose
        footer={
          <Button type="primary" onClick={handleOk}>
            OK
          </Button>
        }
      >
        <Form {...layout} name="basic" form={modalFormInstance} preserve={false}>
          <Form.Item initialValue={702} label="宽度" name="width" rules={modalFormRules.width}>
            <InputNumber min={0} placeholder="宽度" style={formStyle.width100} />
          </Form.Item>

          <Form.Item initialValue={260} label="高度" name="height" rules={modalFormRules.height}>
            <InputNumber min={0} placeholder="高度" style={formStyle.width100} />
          </Form.Item>
        </Form>
      </Modal>
    </div>
  )
}

const mapStateToProps = state => ({
  instance: state.material.instance,
})

const mapDispatchToProps = dispatch => ({
  setInstance: instance => {
    dispatch(setInstance(instance))
  },
})

export default connect(mapStateToProps, mapDispatchToProps)(Material)
